import * as React from 'react';

const StoresMap = () => (
  <iframe
    src="https://www.google.com/maps/d/embed?mid=1BgZ-2cKrwYASfLWrNzXjfkcZDwoviQTt"
    title="Mapa predajní Daffer"
    width="100%"
    height="280"
  />
);

export default StoresMap;
